import { render, staticRenderFns } from "./RateTable.vue?vue&type=template&id=a29e2bce&"
import script from "./RateTable.vue?vue&type=script&lang=ts&"
export * from "./RateTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports